import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {Global} from '@emotion/core'
import styled from '@emotion/styled'
import vars from '../styles/vars'
import Sidebar from '../components/Sidebar'
import MenuButton from '../components/MenuButton'
import global from '../styles/global'

/* eslint-enable */

const Wrapper = styled('div')`
    display: grid;
    grid-template-columns: 0.5fr 4fr;
    min-height: 100vh;
    @media (min-width: ${vars.bpLargerThanTablet}) {
        grid-template-columns: 1.25fr 4fr;
    }

    @media (min-width: ${vars.bpLargerThanDesktophd}) {
        grid-template-columns: 1.35fr 4fr;
    }
`

const Main = styled('main')`
    margin-top: 5rem;
`

class TemplateWrapper extends Component {
    state = {
        menuIsOpen: false,
    }

    toggleMenu = e => {
        const state = this.state
        if (e.target || state.menuIsOpen) {
            state.menuIsOpen = !state.menuIsOpen
            this.setState(state)
        }

        if (typeof window !== 'undefined' && typeof window.ga !== 'undefined') {
            window.ga('send', 'event', {
                eventCategory: 'UI',
                eventAction: 'click',
                eventLabel: 'Toggle Menu',
            })
        }
    }

    closeMenu = () => {
        this.setState({menuIsOpen: false})
    }

    render() {
        const {children} = this.props
        return (
            <Wrapper>
                <Global styles={global} />
                <Helmet
                    title="Monkeywrench Books | Insurgent literature for aspiring partisans"
                    meta={[
                        {
                            name: 'apple-mobile-web-app-title',
                            content: 'Monkeywrench Books',
                        },
                        {
                            name: 'application-name',
                            content: 'Monkeywrench Books',
                        },
                        {
                            name: 'description',
                            content:
                                'Monkeywrench Books is a radical bookstore and social space in Austin, TX',
                        },
                        {
                            name: 'keywords',
                            content:
                                'austin, texas, anarchist, communist, autonomy, liberation, radical, books, literature, events, zines, DIY',
                        },
                    ]}
                >
                    <html lang="en" />
                </Helmet>
                <MenuButton
                    handleClick={this.toggleMenu}
                    isOpen={this.state.menuIsOpen}
                />
                <Sidebar
                    in={this.state.menuIsOpen}
                    onLinkClick={this.closeMenu}
                />
                <Main onClick={this.closeMenu}>{children}</Main>
            </Wrapper>
        )
    }
}

export default TemplateWrapper
